import React, { useEffect } from "react";
import {
  ResumeContainer,
  ResumeTitle,
  ResumeWrapper,
  ResumeAside,
  ResumeDivDestrezas,
  ResumeList,
  ResumeListItem,
  ResumeLink,
  ResumeSubContainer,
  ResumeContentDivContainer,
} from "./Resume.elements";
import OficialStudies from "../OficialStudies/OficialStudies";
import Education from "../Education/Education";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Resume({ id, light }) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const borrar = () => {
    document.querySelectorAll("#indice a").forEach((elemento) => {
      if (document.querySelector("#indice .active")) {
        elemento.classList.remove("active");
      }
    });
  };

  const activar = (elemento) => {
    borrar();
    elemento.target.classList.add("active");
  };

  return (
    <ResumeContainer id={id} className="seccion" light={light}>
      <ResumeTitle data-aos="fade-up" light={light}>
        FORMACIÓN
      </ResumeTitle>
      <ResumeSubContainer>
        <ResumeWrapper data-aos="fade-right" data-aos-easing="ease-in-sine">
          <ResumeAside id="indice">
            <ResumeDivDestrezas>
              <ResumeList light={light}>
                <ResumeListItem className="nav_item" data-url="estudios">
                  <ResumeLink
                    light={light}
                    onClick={activar}
                    href="#estudios"
                    id="1"
                    className="active"
                  >
                    Trayectoria
                  </ResumeLink>
                </ResumeListItem>
                <ResumeListItem className="nav_item" data-url="education">
                  <ResumeLink
                    light={light}
                    href="#education"
                    onClick={activar}
                    id="2"
                  >
                    Formación Adicional
                  </ResumeLink>
                </ResumeListItem>
              </ResumeList>
            </ResumeDivDestrezas>
          </ResumeAside>
        </ResumeWrapper>
        <ResumeContentDivContainer>
          <OficialStudies light={light} />
          <Education light={light} />
        </ResumeContentDivContainer>
      </ResumeSubContainer>
    </ResumeContainer>
  );
}
